import React from 'react';
import ImageUpload from './ImageUpload';

function App() {
  return (
    <div className="App">
      <h1>Image Averaging App</h1>
      <ImageUpload />
    </div>
  );
}

export default App;
